import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableSchool } from 'types/school';

export const SCHOOLS_TRASH_KEY = 'schools_trash';

function fetchSchoolsTrash() {
  const requestURL = '/schools/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableSchool[] }) => data || []);
}

export function useSchoolsTrash() {
  return useQuery({
    queryKey: [SCHOOLS_TRASH_KEY],
    queryFn: () => fetchSchoolsTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
